import { DelaysParetoReportPage } from "./DelaysParetoReportPage";

type Props = {};
const DelaysParetoReport = (props: Props) => {
	return <DelaysParetoReportPage />;
};
export default DelaysParetoReport;
